const defaultState = {
    text: 'klik op het pijltje om bouwstenen te halen'
};

export default function reducer(state = defaultState, action) {
    switch (action.type) {
        case 'SET_BOTTOMBAR_TEXT': {
            return {
                ...state,
                text: action.payload
            };
        }
        default: {
            return state;
        }
    }
}
